//
//
//
//
//
//
//
//
//

export default {
  props: {
    value: {
      type: Object | undefined,
      required: true
    },
  },

  computed: {
    rol: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      }
    }
  },
}
